module.exports = __webpack_public_path__ + "static/img/2_1_2_1.97560e14.jpg";